import React, { useState, useEffect } from "react";
import PT from "prop-types";
import * as S from "./styled";
import { Input } from "../index-styled";
import { useForm, FormContext } from "react-hook-form";
import { AbstractField, AbstractControlledField } from "_c/form/Field";
import { UserAPI } from "@/api/user";
import { useNotify } from "@/hooks/useNotify";
import { restorePasswordRequestSchema } from "@/validation/restore-password";
import { Button } from "_c/button";
import GoMailBtn from "../GoMailBtn";
import FormMessage from "_c/form/Message";
import { ProgressEmitter } from "_c/GlobalProgress/emitter";
import PhoneEmailToggler from "../PhoneEmailToggler";
import PhoneInput from "_c/form/PhoneInput";
import Info from "_c/atoms/Info";
import { Translate } from "@/i18n/utils";
import { FEAT_FLAG_EMAIL_RESTORE_PASS } from "@/misc/featureFlags";
import { DEFAULT_RESTORE_PASS_STRATEGY } from "@/config";

const RestorePassword = ({ t, ...props }) => {
  const [{ phone, email }, setValues] = useState({});
  const [success, setSuccess] = useState(false);
  const [strategy, setStrategy] = useState(DEFAULT_RESTORE_PASS_STRATEGY);
  const methods = useForm({
    validationSchema: restorePasswordRequestSchema,
  });
  const { handleSubmit, formState } = methods;
  useEffect(() => {
    methods.register("strategy");
  }, [methods.register]);
  useEffect(() => {
    methods.setValue("strategy", strategy);
  }, [strategy]);
  const { isSubmitting } = formState;
  const { notifyError } = useNotify();
  const onSubmit = async ({ email, phone }) => {
    try {
      ProgressEmitter.start();
      await UserAPI.requestRestorePasswordLink(
        strategy === "phone" ? { phone } : { email }
      );
      setValues({ email, phone });
      setSuccess(true);
    } catch (e) {
      console.error(e);
      notifyError(Translate.serverError(t, e));
    } finally {
      ProgressEmitter.end();
    }
  };
  if (success) {
    const msg = t(`login:restore_pass_success_${strategy}`, { email, phone });
    if (strategy === "phone") {
      return (
        <S.Wrap>
          <Info cta>{msg}</Info>
        </S.Wrap>
      );
    }
    return (
      <S.Wrap>
        <FormMessage message={msg} />
        <GoMailBtn onClose={props.hideForm} t={t} email={email} />
      </S.Wrap>
    );
  }
  return (
    <FormContext {...methods}>
      <S.Wrap onSubmit={handleSubmit(onSubmit)}>
        {FEAT_FLAG_EMAIL_RESTORE_PASS && (
          <PhoneEmailToggler value={strategy} onChange={setStrategy} t={t} />
        )}
        {strategy === "phone" && (
          <AbstractControlledField
            name="phone"
            id="restore_pass_phone"
            autoFocus
            t={t}
            locale={props.locale}
            placeholder={t("common:phone")}
            inputComponent={Input}
            Component={PhoneInput}
          />
        )}
        {strategy === "email" && (
          <AbstractField
            t={t}
            autoFocus
            Component={Input}
            name="email"
            type="email"
            placeholder="E-mail"
            aria-label="E-mail"
            id="restore_pass_email"
          />
        )}
        <Button greenish small type="submit" disabled={isSubmitting}>
          {t("login:restore_pass")}
        </Button>
        <Button
          onClick={props.hideForm}
          style={{ marginTop: "10px" }}
          negative
          type="button"
          small
        >
          {t("login:restore_pass_cancel")}
        </Button>
      </S.Wrap>
    </FormContext>
  );
};
RestorePassword.propTypes = {
  hideForm: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default RestorePassword;
